export enum WeightOutOfRangeType {
  BMI_UNDER_19 = 'BMI_UNDER_19',
  WEIGHT_DECREASE_1_MONTH_3_PERCENT = 'WEIGHT_DECREASE_1_MONTH_3_PERCENT',
  WEIGHT_DECREASE_3_MONTHS_5_PERCENT = 'WEIGHT_DECREASE_3_MONTHS_5_PERCENT',
  WEIGHT_DECREASE_6_MONTHS_10_PERCENT = 'WEIGHT_DECREASE_6_MONTHS_10_PERCENT',
}
